import { CardItem, Skeleton } from "@walmart-web/livingdesign-components"
import React from "react"

const SwitchingNodeSkeleton = () => {
	return (
		<CardItem className="card-item node">
			<div className="node-header" />
			<div className="node-container">
				<div className="node-container-row">
					<Skeleton className="node-item" variant="rectangle" />
					<Skeleton className="node-item" variant="rectangle" />
				</div>
				<div className="node-container-row">
					<Skeleton className="node-item" variant="rectangle" />
					<Skeleton className="node-item" variant="rectangle" />
				</div>
				<hr />
				<div className="node-container-row">
					<Skeleton className="node-item" variant="rectangle" />
					<Skeleton className="node-item" variant="rectangle" />
				</div>
			</div>
		</CardItem>
	)
}

export default SwitchingNodeSkeleton
